<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <table *ngIf="consulta?.lista.length>1" class="table table-striped table-sm">
      <tr class="text-warning text-center">
        <th>Chassi</th>
        <th>Motor</th>
      </tr>
      <tr *ngFor="let v of consulta?.lista" class="text-center">
        <td>{{v?.chassi || 'NÃO INFORMADO'}}</td>
        <td>{{v?.motor || 'NÃO INFORMADO'}}</td>
      </tr>
    </table>

  </ng-container>

</app-card-consulta>
